export default "__VITE_ASSET__DAx_fDbS__"